module.exports = __webpack_public_path__ + "img/coinbankB15.779a0d6d.jpg";